export const STORE_DISPLAY_NAME = 'CamiYui by PROSOL';
export const HOME_SCREEN_APP_NAME = 'CamiYui';
export const BRAND_TIFFANY_BLUE = '#0ABAB5';
